import * as AntdIcons from '@ant-design/icons-vue'

/**
 * 图标加载器 - 自动加载所有Ant Design图标
 */
export class IconLoader {
  private static instance: IconLoader
  private iconMap: Map<string, any> = new Map()
  private iconList: Array<{ name: string; component: any }> = []

  private constructor() {
    this.loadAllIcons()
  }

  /**
   * 获取单例实例
   */
  public static getInstance(): IconLoader {
    if (!IconLoader.instance) {
      IconLoader.instance = new IconLoader()
    }
    return IconLoader.instance
  }

  /**
   * 加载所有图标
   */
  private loadAllIcons(): void {
    // 遍历所有导出的图标
    Object.entries(AntdIcons).forEach(([name, component]) => {
      // 只处理以Outlined结尾的图标（最常用的类型）
      if (name.endsWith('Outlined')) {
        this.iconMap.set(name, component)
        this.iconList.push({ name, component })
      }
    })

    console.log(`图标加载器已加载 ${this.iconList.length} 个图标`)
  }

  /**
   * 获取所有图标列表
   */
  public getAllIcons(): Array<{ name: string; component: any }> {
    return [...this.iconList]
  }

  /**
   * 根据名称获取图标组件
   */
  public getIconByName(name: string): any {
    return this.iconMap.get(name)
  }

  /**
   * 根据图标代码获取图标组件
   * @param iconCode 图标代码，如 "[HomeOutlined]"
   */
  public getIconByCode(iconCode: string): any {
    if (!iconCode || !iconCode.startsWith('[') || !iconCode.endsWith(']')) {
      return null
    }
    
    const iconName = iconCode.slice(1, -1) // 移除 [ ] 符号
    return this.getIconByName(iconName)
  }

  /**
   * 检查图标是否存在
   */
  public hasIcon(name: string): boolean {
    return this.iconMap.has(name)
  }

  /**
   * 获取图标总数
   */
  public getIconCount(): number {
    return this.iconList.length
  }

  /**
   * 搜索图标（按名称模糊匹配）
   */
  public searchIcons(keyword: string): Array<{ name: string; component: any }> {
    const lowerKeyword = keyword.toLowerCase()
    return this.iconList.filter(icon => 
      icon.name.toLowerCase().includes(lowerKeyword)
    )
  }

  /**
   * 获取图标映射表（用于兼容现有代码）
   */
  public getIconMap(): Record<string, any> {
    const map: Record<string, any> = {}
    this.iconMap.forEach((component, name) => {
      map[name] = component
    })
    return map
  }
}

/**
 * 便捷函数：获取图标加载器实例
 */
export const getIconLoader = () => IconLoader.getInstance()

/**
 * 便捷函数：获取所有图标列表
 */
export const getAllIcons = () => getIconLoader().getAllIcons()

/**
 * 便捷函数：获取图标映射表
 */
export const getIconMap = () => getIconLoader().getIconMap()

/**
 * 便捷函数：根据名称获取图标组件
 */
export const getIconByName = (name: string) => getIconLoader().getIconByName(name)

/**
 * 便捷函数：根据图标代码获取图标组件
 */
export const getIconByCode = (iconCode: string) => getIconLoader().getIconByCode(iconCode)
